module.exports = __webpack_public_path__ + "img/guangdongkexuezhongxin.ad227283.png";